
export const handleAdditionalBrands = (brandName: string | undefined) => {
  return (
    brandName === "Victoria Beckham" ||
    brandName === "Nina Ricci" ||
    brandName === "Rabanne" ||
    brandName === "Ogier"
  );
};
